import { DEV_MODE } from '@/config/dev-mode';

/**
 * 복지찬스(스마트웰) 정기구독 상품 ID.
 * - 개발환경(VITE_APP_MODE=development): 테스트 상품(p_test_sub_smartwel01)
 * - 그 외(운영/스테이징 등): 정식 상품(p_sub_smartwel01)
 */
export const SMARTWEL_SUBSCRIPTION_PRODUCT_ID = DEV_MODE
  ? 'p_test_sub_smartwel01'
  : 'p_sub_smartwel01';

/**
 * 제휴 파트너 메타데이터 (로고, 표시 이름 등).
 *
 * 신규 파트너 추가 시 본 매핑에 항목을 추가하고,
 * `public/images/partner/{key}/` 경로에 로고 파일을 배포한다.
 * (`/partner/*`는 Vue 라우트와 충돌하므로 사용 금지)
 *
 * 향후 백엔드의 `myInfo.partner` 응답에 logoUrl/name이 포함되면 이 매핑은 제거 가능.
 */
export const PARTNER_META = {
  smartwel: {
    name: '복지찬스',
    /** 기본(어두운 배경 위) wordmark — 검정 텍스트 */
    logoPath: '/images/partner/smartwel/smartwel-wordmark__black.png',
    /** 반전(밝은 배경/투명 위) wordmark — 흰 텍스트 */
    logoPathInverted: '/images/partner/smartwel/smartwel-wordmark__white.png',
  },
};

/**
 * 파트너 식별자(provider)로 메타데이터 조회.
 * logoUrl 계열은 현재 origin 기준 절대 URL로 변환되어 반환됨 (앱이 직접 fetch 가능).
 *
 * @param {string} provider - 파트너 식별자 (예: 'smartwel')
 * @returns {{ name: string, logoUrl: string, logoUrlInverted: string } | null}
 */
export const getPartnerMeta = (provider) => {
  const meta = PARTNER_META[provider];
  if (!meta) return null;
  const origin = window.location.origin;
  return {
    name: meta.name,
    logoUrl: `${origin}${meta.logoPath}`,
    logoUrlInverted: `${origin}${meta.logoPathInverted}`,
  };
};
